import useSWR from 'swr';
import {
  IOpenCallsResponse,
  ReviewCountsResponse,
  SubmissionCountsResponse
} from 'typings/event';

export const useEventReviewCount = () => {
  const { data, error, ...rest } = useSWR<ReviewCountsResponse>([
    `/v5/home-client/stats/review/counts`,
    true
  ]);

  return {
    ...rest,
    data: data || {},
    error,
    hasError: Boolean(error),
    isLoading: !data && !error
  };
};

export const usePapersCount = (userId: string) => {
  const { data, error, ...rest } = useSWR<SubmissionCountsResponse>([
    `/v3/discovery/papers/count?authors=${userId}`,
    true
  ]);

  return {
    ...rest,
    data: data || ({} as SubmissionCountsResponse),
    error,
    hasError: Boolean(error),
    isLoading: !data && !error
  };
};

export const usePostersCount = (userId: string) => {
  const { data, error, ...rest } = useSWR<SubmissionCountsResponse>([
    `/v3/discovery/posters/count?authors=${userId}`,
    true
  ]);

  return {
    ...rest,
    data: data || ({} as SubmissionCountsResponse),
    error,
    hasError: Boolean(error),
    isLoading: !data && !error
  };
};

export const useOpenCalls = (offset: number, itemsPerPage: number) => {
  const { data, error, ...rest } = useSWR<IOpenCallsResponse>([
    `/v3/discovery/open-calls?&offset=${
      offset * itemsPerPage
    }&limit=${itemsPerPage}`,
    true // require auth token
  ]);

  return {
    ...rest,
    data,
    error,
    hasError: Boolean(error),
    isLoading: !data && !error
  };
};
